module.exports = __webpack_public_path__ + "img/rotate-left.d69e950c.svg";